/* eslint-disable react-hooks/exhaustive-deps */
import React, { memo, useCallback, useEffect, useRef, useState } from "react";

import {
  Card,
  CardBody,
  Carousel,
  CarouselControl,
  CarouselItem,
  Col,
  Collapse,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  UncontrolledTooltip,
} from "reactstrap";

import "./FormsData.scss";
//i18n
import { withTranslation,useTranslation } from "react-i18next";
import axios from "axios";
import { showToast } from "../../../../functions/utils";
import FieldFormValue from "./fieldFormValue";
import Switch from "react-input-switch";

const FormsData = (props) => {
  const printRef = useRef();
  const { t } = useTranslation();

  const [activeTabForm, setActiveTabForm] = useState(0);
  const [activeSlide, setActiveSlide] = useState(0);
  const indexHistory = props?.index + 1 || 0;
  const qtdTabs = props?.formData?.length;

  const handleTabClick = (tabId) => {
    setActiveTabForm(tabId);
  };

  const handleSlideNext = () => {
    setActiveSlide((activeSlide + 1) % totalSlides);
  };

  const handleSlidePrevious = () => {
    setActiveSlide((activeSlide - 1 + totalSlides) % totalSlides);
  };

  const slidesPerView = 3; // Defina o número de abas exibidas por vez
  const totalSlides = Math.ceil(qtdTabs / slidesPerView);

	const [valueSwitch, setValueSwitch] = useState(localStorage.getItem("switchAccordionKey") || 'closed');

  const handleSwitchToggle = () => {
    if (valueSwitch === 'closed') {
      setValueSwitch('opened');
      localStorage.setItem("switchAccordionKey", 'opened');
    } else {
      setValueSwitch('closed');
      localStorage.setItem("switchAccordionKey", 'closed');
    }
  };
 
  if (props?.formData) {
    return (
      <>
        <div ref={printRef}>
          <Col>
            <Card className="mt-2 pointer" key="2">
              <CardBody className="p-0 ">
              <div  style={{ display: "flex", alignItems: "center",margin:'10px 0px 10px 0px' }}>
              <h6 className="text-left" style={{ marginRight: "10px" }}>{t("Expand all fields")}</h6>
                <Switch on='opened' off='closed' value={valueSwitch} onChange={
                  handleSwitchToggle
                }  />
            </div>
                <Carousel activeIndex={activeSlide} next={handleSlideNext} previous={handleSlidePrevious} interval={false}>
                  {props?.formData?.reduce((acc, objectZero, index) => {
                    if (index % slidesPerView === 0) {
                      acc.push([]);
                    }
                    acc[acc.length - 1].push(objectZero);
                    return acc;
                  }, []).map((slideTabs, slideIndex) => (
                    <CarouselItem key={slideIndex}>
                      <Nav tabs className="nav-tabs-form nav-justified mt-3" style={{ width: "100%", textAlign: "left" }}>
                        {slideTabs.map((objectZero, tabIndex) => (
                          <NavItem key={tabIndex} className="nav-item-form">
                            <NavLink
                              className={`nav-link-form ${activeTabForm === (slideIndex * slidesPerView + tabIndex) ? "active" : ""}`}
                              onClick={() => handleTabClick(slideIndex * 3 + tabIndex)}
                              id={`tooltip-${slideIndex * 3 + tabIndex}`}
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                            >
                              <div className="tab-form-title">
                                {objectZero?.name}
                              </div>
                            </NavLink>
                            <UncontrolledTooltip placement="top" target={`tooltip-${slideIndex * slidesPerView + tabIndex}`}>
                              {objectZero?.name}
                            </UncontrolledTooltip>
                          </NavItem>
                        ))}
                      </Nav>
                      <TabContent activeTab={activeTabForm} className="text-muted">
                        {slideTabs.map((objectZero, tabIndex) => (
                          <TabPane key={tabIndex} tabId={slideIndex * 3 + tabIndex} className="w-100">
                            {objectZero?.children?.map((objectOne, indexOne) => (
                              <>
                                <SeletorContent
                                  data={objectOne}
                                  index={indexOne}
                                  slideIndex={slideIndex}
                                  tabIndex={tabIndex}
                                  indexOne={indexOne}
                                  indexHistory={indexHistory}
                                  valueSwitch={valueSwitch}
                                ></SeletorContent>
                              </>
                            ))}
                          </TabPane>
                        ))}
                      </TabContent>
                    </CarouselItem>
                  ))}
                  {qtdTabs > slidesPerView ? (
                    <>
                      <CarouselControl className="control-prev-form" direction="prev" directionText="Previous" onClickHandler={handleSlidePrevious} />
                      <CarouselControl className="control-next-form" direction="next" directionText="Next" onClickHandler={handleSlideNext} />
                    </>
                  ) : (
                    <></>
                  )
                  }

                </Carousel>

                <ButtonDownload chatId={props?.chatId} protocol={props.protocol} />
              </CardBody>
            </Card>
          </Col>
        </div>
      </>
    );
  }
  else {
    return (
      <>
      </>
    );
  }
};
export default withTranslation()(React.memo(FormsData));

const AccordionForm = memo((props) => {
  const { valueSwitch } = props;
  const [collapseForm, setCollapseForm] = useState({});

  useEffect(() => {
    if (valueSwitch==='opened') {
      const aux = {};
      props.children.forEach((_, index) => {
        aux[index] = true;
      });
      aux[props?.index] = true;
      setCollapseForm(aux);
    } else {
      setCollapseForm({});
    }
  }, [valueSwitch, props.children]);

  const toggleCollapse = (index) => {
    setCollapseForm((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };
  return (
    <>
      <div className="tab-acordeon-timeline w-100">
        <div key={props?.index} className="accordion-form extra-info-sub-item" onClick={() => {
           toggleCollapse(props?.index);
        }}>
          <div className="accordion-form-title">
            <div className="text-limit-2l" id={`tooltip-accordion-title-${parseInt(`${props?.idexTooltip}`, 10)}`} style={{ display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden", textOverflow: "ellipsis", width: "100%", margin: "0px 10px 0px 0px" }}>
              {props?.name}
            </div>
            <UncontrolledTooltip placement="top" target={`tooltip-accordion-title-${parseInt(`${props?.idexTooltip}`, 10)}`}>
              {props?.name}
            </UncontrolledTooltip>
            <span className="accordion-form-icon" align="left">
              <i className={`bx bx bxs-chevron-right color font-size-15 item ${collapseForm[props?.index] || props?.accordionChild  ? "opened" : "closed"}`} />
            </span>
          </div>
        </div>
      </div>
      <Collapse className="mx-0 my-1 w-100" isOpen={props?.accordionChild || collapseForm[props?.index] }>
        {props.children?.map((objectOne, indexOne) => (
          <>
            <SeletorContent
              data={objectOne}
              index={indexOne}
              slideIndex={props?.slideIndex}
              tabIndex={props?.tabIndex}
              indexOne={props?.indexOne}
              accordionChild={true}
              indexHistory={props?.indexHistory}
              valueSwitch={props?.valueSwitch}

            />
          </>
        ))
        }

      </Collapse>
    </>
  );
});

const SeletorContent = memo((props) => {
  if (props?.data?.hasOwnProperty("children")) {
    return (
      <>
        <AccordionForm
          name={props?.data?.name}
          children={props?.data?.children}
          index={props?.index}
          slideIndex={props?.slideIndex}
          tabIndex={props?.tabIndex}
          indexOne={props?.indexOne}
          accordionChild={props?.accordionChild || false}
          indexHistory={props?.indexHistory}
          idexTooltip={`${props?.slideIndex}${props?.tabIndex}${props?.indexOne}${props?.index}${props?.indexHistory}`}
          valueSwitch={props?.valueSwitch}
        ></AccordionForm>
      </>
    );
  }
  else if (props?.data?.hasOwnProperty("type") && props?.data?.type !== "note") {
    return (
      <>
        <FieldFormValue
          name={props?.data?.name}
          value={props?.data?.value}
          type={props?.data?.type}
          index={props?.index}
          idexTooltip={`${props?.slideIndex}${props?.tabIndex}${props?.indexOne}${props?.index}${props?.indexHistory}`}
        />
      </>
    );
  }
});

const ButtonDownload = memo((props) => {
  const { t } = useTranslation();

  const [isDownload, setIsDownload] = React.useState(false);

  const handleDownloadPdf = useCallback(() => {
    const chatId = props?.chatId;

    setIsDownload(true);
    axios
      .get(`/ticket-download?${chatId ? `&id=${chatId}` : ""}`, {
        method: "GET",
        responseType: "blob", //Force to receive data in a Blob Format
      })
      .then((response) => {
        const file = new Blob([response.data], {
          type: "application/pdf",
        });
        const fileURL = URL.createObjectURL(file);
        setIsDownload(false);
        const link = document.createElement("a");
        link.href = fileURL;
        link.setAttribute(
          "download",
          `ticket-${props.protocol || props.chatId}.pdf`
        );
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      })
      .catch((error) => {
        console.error(error);
        showToast(t("There was an error downloading conversation"), "error");
      });
  }, [props?.chatId]);

  return (
    <>
      <div>
        <UncontrolledTooltip placement="auto" target={`downloadButton`}>
          {t("Download form data as pdf")}
        </UncontrolledTooltip>
        <div
          id="downloadButton"
          className="download-button"
          onClick={() => {
            handleDownloadPdf();
          }}
          disabled={isDownload}
        >
          {isDownload ? (
            <div>
              <i className="fa fa-spinner fa-spin"></i>
            </div>
          ) : (
            <i
              id="tooltipdownload"
              style={{ fontSize: "1.5em", marginBottom: "0.4em" }}
              className={"mdi mdi-download"}
            />
          )}
        </div>
      </div>
    </>
  );
});
